import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import UiFormControlLabel from 'ui-components/ui-form-control-label/UiFormControlLabel';
import UiCheckbox from 'ui-components/ui-checkbox/UiCheckbox';
import { getCurrentSlice } from 'utils';

/**
 * فیلتر انتخاب نوع بازه سنی
 */
export const AgeFilter = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { componentName, parentPlatform, className } = props;
  const filter = useSelector((state) =>
    parentPlatform
      ? state[state.filterReducer.filtersContext].filters[parentPlatform][
          componentName
        ]
      : state[state.filterReducer.filtersContext].filters[componentName]
  );
  const reducerName = useSelector(
    (state) => state.filterReducer.filtersContext
  );
  const { selectedIds, isDisabled } = filter;
  const { setSelectedFilterIds } = getCurrentSlice(reducerName);

  const ageList = [
    { title: t('filter:lessThanEighteen'), id: '<=18' },
    { title: t('filter:betweenNineteenAndTwentyNine'), id: '19-29' },
    { title: t('filter:betweenThirtyAndThirtyNine'), id: '30-39' },
    { title: t('filter:lessThanFourty'), id: '>=40' },
  ];

  const handleChangeAge = (event, id) => {
    dispatch(
      setSelectedFilterIds({
        id,
        isChecked: event.target.checked,
        componentName,
        parentPlatform,
      })
    );
  };

  return (
    <div className={classNames('grid', className)}>
      {ageList?.map(({ id, title }) => {
        return (
          <UiFormControlLabel
            key={id}
            className='mr-0'
            label={title}
            control={
              <UiCheckbox
                checked={selectedIds?.includes(id)}
                name={id}
                onChange={(event) => handleChangeAge(event, id)}
                disabled={isDisabled}
              />
            }
          />
        );
      })}
    </div>
  );
};

AgeFilter.propTypes = {
  componentName: PropTypes.string.isRequired,
  parentPlatform: PropTypes.string,
  className: PropTypes.string,
};
